import React from 'react'

const TriangularAlertIcon = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1318 2.51943C11.5157 1.84761 12.4844 1.84761 12.8682 2.51943L23.1451 20.5039C23.526 21.1705 23.0446 22 22.2768 22H1.72318C0.955356 22 0.47399 21.1705 0.854937 20.5039L11.1318 2.51943Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.125 7.25H10.875V15.25H13.125V7.25ZM13.125 17.25H10.875V19.25H13.125V17.25Z"
        fill="#DE5A48"
      />
    </svg>
  )
}

export default TriangularAlertIcon
